import { render, staticRenderFns } from "./Experiments.vue?vue&type=template&id=98c7be98&scoped=true"
import script from "./Experiments.vue?vue&type=script&lang=js"
export * from "./Experiments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c7be98",
  null
  
)

export default component.exports